export default __webpack_public_path__ + "static/media/casadelarte4.17b89973.jpg";